<template>
  <div class="base-toast-container" :class="`base-toast-container--${position}`">
    <transition-group name="base-toast-slide" tag="div" class="base-toast-stack">
      <BaseToast
        v-for="t in toasts"
        :key="t.id"
        v-bind="t"
        @dismiss="remove"
      />
    </transition-group>
  </div>
</template>

<script>
import BaseToast from '@/components/base/BaseToast.vue';

let UID = 0;

export default {
  name: 'BaseToastContainer',
  components: { BaseToast },
  data() {
    return {
      toasts: [],
      position: 'top-right',
      maxStack: 5,
    };
  },
  methods: {
    add(opts) {
      const id = ++UID;
      const toast = {
        id,
        type:        opts.type        || 'info',
        content:     opts.content     || '',
        duration:    typeof opts.duration === 'number' ? opts.duration : 5000,
        dismissible: opts.dismissible !== false,
      };
      this.toasts.push(toast);
      while (this.toasts.length > this.maxStack) this.toasts.shift();
      return id;
    },
    remove(id) {
      const idx = this.toasts.findIndex((t) => t.id === id);
      if (idx >= 0) this.toasts.splice(idx, 1);
    },
    clear() { this.toasts = []; },
  },
};
</script>

<style scoped>
.base-toast-container {
  position: fixed;
  z-index: 1200;
  pointer-events: none;
  padding: 20px;
}
.base-toast-container--top-right    { top: 0; right: 0; }
.base-toast-container--top-left     { top: 0; left: 0; }
.base-toast-container--bottom-right { bottom: 0; right: 0; }
.base-toast-container--bottom-left  { bottom: 0; left: 0; }

.base-toast-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
}
.base-toast-container--top-left .base-toast-stack,
.base-toast-container--bottom-left .base-toast-stack { align-items: flex-start; }

/* Animação slide-in/out */
.base-toast-slide-enter-active,
.base-toast-slide-leave-active {
  transition: transform var(--duration) var(--ease), opacity var(--duration) var(--ease);
}
.base-toast-slide-enter {
  transform: translateX(100%);
  opacity: 0;
}
.base-toast-slide-leave-to {
  transform: translateX(20%);
  opacity: 0;
}
.base-toast-slide-move {
  transition: transform var(--duration) var(--ease);
}
</style>
